import { ProgramCardProps } from "@shared/interfaces/ProgramFiles";
import React from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";

interface ProgramListProps {
  programs: ProgramCardProps[];
  activeColor?: string;
}

const ProgramList: React.FC<ProgramListProps> = ({ programs, activeColor }) => {
  const { programId } = useParams();

  return (
    <ul className="space-y-2 mt-1 font-light pl-4">
      {programs.map((program) => (
        <li key={program.id} className="relative">
          <Link
            to={`/program/${program.id}`}
            className={`flex items-center p-2 space-x-3 rounded-md hover:bg-[${activeColor}] ${
              programId === String(program.id) && `bg-[${activeColor}]`
            }`}
          >
            <span className="w-6 h-6">
              {program.icon ? program.icon : "⭐"}
            </span>
            <span className="line-clamp-1 pr-4">{program.name}</span>
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default ProgramList;
